import { useEffect, useState } from "react";

// Google profile pictures (lh3.googleusercontent.com) may refuse requests whose Referer is
// a localhost origin (Capacitor app / local debug), so the referrer is never sent.
const UserAvatar = ({ src, alt, className = "", fallback = null }) => {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [src]);

  if (!src || failed) return fallback;

  return (
    <img
      src={src}
      alt={alt}
      referrerPolicy="no-referrer"
      onError={() => setFailed(true)}
      className={className}
    />
  );
};

export default UserAvatar;
